export const DrawingModeHint = () => (
  <div
    data-testid="drawing-mode-hint"
    style={{
      position: 'absolute',
      top: '12px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 5,
      padding: '8px 14px',
      borderRadius: '8px',
      backgroundColor: 'rgba(33, 37, 41, 0.92)',
      color: '#fff',
      fontSize: '13px',
      fontWeight: 500,
      pointerEvents: 'none',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
      whiteSpace: 'nowrap',
    }}
  >
    Haz clic para unir puntos. Con 3 o más puntos, haz clic en el primer punto
    (círculo púrpura) para cerrar.
  </div>
);
